export default {
  title: 'Alle Kurse',
  searchPH: 'Suche nach Kursnamen',
  noCourses: 'Keine Kurse gefunden',
  nameTaken: 'Dieser Name in der Kategorie existiert bereits.',
  addNewContent: 'Neuen Inhalt hinzufügen',
  delete: 'Löschen',
  cancel: 'Abbrechen',
  delContentTitle: 'Inhalt löschen',
  delContentWarn: 'Bist Du sicher das Du diesen Inhalt löschen willst ?',
  delCourseTitle: 'Kurs löschen',
  delCourseWarn: 'Bist Du sicher das Du den <u>gesamten</u> Kurs löschen willst ?',

  renameCourseTitle: 'Kurs umbenennen',
  renameCourseOK: 'Umbenennen',
  renameCourseLabel: 'Neuer Kursname*',
  renameCoursePlaceholder: 'Neuer Kursname',

  copyCourseTitle: 'Kurs duplizieren',
  copyCourseOK: 'Mit neuem Namen duplizieren',
  copyCourseLabel: 'Neuer Kursname*',
  copyCoursePlaceholder: 'Neuer Kursname',

  changeContentTypeTitle: 'Inhalts-Typ ändern',
  changeContentTypeOK: 'Typ ändern',
  changeContentTypeNew: 'Neuer Typ*',

  saveSuccess: 'Speichern erfolgreich!',
  contentEmpty: 'Dieser Inhalt ist noch leer',
  backToOverview: 'Zur Autor-Tools Übersicht',
  goToContent: 'Zum Inhalt springen',
  content: 'Inhalt',
  editContentButton: 'Inhalt bearbeiten',
  editContent: (step) => `Damit kannst Du den oben angezeigten Inhalt (Nr. <b>${step}</b>) bearbeiten.`,
  editContentType: 'Inhalts-Typ ändern',
  editContentTypeText: 'Damit kannst Du den Typ des Inhalts permanent ändern.<br><u>Achtung:</u> Dabei gehen die aktuellen Eingaben verloren.',
  learningModules: 'Lernbausteine',
  learningChecks: 'Lernüberprüfungen',
  newContentText: (id) => `Damit kannst Du einen neuen Inhalt erstellen.<br>Er wird die Nummer <b>${id}</b> haben.`,
  editCourseNav: 'Kursführung bearbeiten',
  incomplete: 'Unvollständig',
  editCourseNavText: (count) => `Damit kannst Du die Kursführung bearbeiten. Insgesamt hat der Kurs <b>${count}</b> Inhalte.`,

  renameCourseButton: 'Kurs umbenennen',
  renameCourseAction: 'Der Kurs wird umbenannt.',
  copyCourseButton: 'Kurs duplizieren',
  copyCourseAction: 'Der Kurs wird mit einem neuen Namen dupliziert.',
  removeContentButton: 'Inhalt löschen',
  removeContentAction: 'Der aktuelle Inhalt wird gelöscht.',
  removeCourseButton: 'Kurs löschen',
  removeCourseAction: 'Der <b>gesamte Kurs</b> wird gelöscht.',
}
